module.exports = __webpack_public_path__ + "images/angebot/saubere_filme_angebot.jpg";